import { render, staticRenderFns } from "./PortalOwners.vue?vue&type=template&id=22bca3e7&scoped=true&"
import script from "./PortalOwners.vue?vue&type=script&lang=js&"
export * from "./PortalOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bca3e7",
  null
  
)

export default component.exports